import { FC, useContext, useEffect } from "react";

import useFetch from "src/hooks/useFetch";
import { downloadPdfFile } from "src/helpers/downloadFile";
import { LoaderContext } from "src/context/loaderContext";

import { DownloadZipResponseType } from "src/pages/dashboard/types";
import { APIEndpoints } from "src/types/apiTypes";
import { CaseDetailAPIResponse, CaseDetailProps, StepperType } from "./types";


const StepperModal: FC<StepperType> = ({ onClick, caseId }): JSX.Element => {
  const { hideLoader, setLoader } = useContext(LoaderContext);


  const { data: caseDetails } =
    useFetch<CaseDetailAPIResponse>(APIEndpoints.CASE_DETAIL_POPUP, { case_id: caseId })


  
  const {
    loading: downloadCaseLoader, data: downloadCaseData, error: downloadCaseError, mutate: downloadRequestForm, removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadZipResponseType>(APIEndpoints.DOWNLOAD_REQUEST_FORM);

  useEffect(() => {
    if (downloadCaseData || downloadCaseError) {
      if(downloadCaseData && caseDetails) {
        const { response } = downloadCaseData;
        downloadPdfFile(response, `case_${caseId}_reports.pdf`);
      }
      hideLoader();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadCaseData, downloadCaseError]);

  const downloadRequestFileByCaseId = () => {
    if (downloadCaseData || downloadCaseError) clearRequestFileData();
    setLoader();

    downloadRequestForm({}, {}, { ref_id: caseId, type: 'request', ref_type: 'Case' });
  };

  const downloadInsuranceFileByCaseId = (insuranceId: number) => {
    if (downloadCaseData || downloadCaseError) clearRequestFileData();
    setLoader();

    downloadRequestForm({}, {}, { ref_id: insuranceId, type: 'investigation', ref_type: 'Insurance' });
  };



  return (
    <div className={`modal fade show show show-modal`} id="typeModal" aria-labelledby="typeModalLabel" aria-hidden="true" >
      <div className="modal-dialog modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="text-center mb-0">Case {caseId} Details
              <button disabled={downloadCaseLoader} id="request-link" className="btn btn-primary ms-2" onClick={downloadRequestFileByCaseId}>
                <i className="bi bi-file-pdf-fill"></i> Request
              </button>
            </h1>

            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClick}></button>
          </div>

          <div className="modal-body">
            {caseDetails && caseDetails.data ?
              (Array.isArray(caseDetails.data) && caseDetails.data.length > 0 ?
                caseDetails.data.map((kase: CaseDetailProps) => (
                <div className="card mb-3" key={kase.case_id}>
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-3">
                        <b>Insurance Name:</b>
                      </div>
                      <div className="col-md-6">
                        {kase.insurance_name}
                      </div>
                      <div className="col-md-3 pr-0 text-end">
                        <button className="btn btn-primary ms-2" disabled={downloadCaseLoader} onClick={() => downloadInsuranceFileByCaseId(kase.insurance_id)}>
                          <span className="fa fa-file-pdf"></span> Results
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="container">
                    <div className={"row mb-2"}>
                      <div className={"col-12 col-md-6 mb-2 mb-md-0"}>
                        <div className={"row"}>
                          <div className="col-6 col-md-6">
                            <b>Product Coverage:</b>
                          </div>
                          <div className="col-6 col-md-6">
                          {kase.out_network_display ? kase.out_network_tab.product_coverage : kase.in_network_tab.product_coverage}
                        </div>
                        </div>
                      </div>
                      <div className={"col-12 col-md-6 mb-2 mb-md-0"}>
                        <div className={"row"}>
                          <div className="col-6 col-md-6">
                            <b>Product Copay:</b>
                          </div>
                          <div className="col-6 col-md-6">
                          {kase.out_network_display ? kase.out_network_tab.product_copay : kase.in_network_tab.product_copay}
                        </div>
                        </div>
                      </div>
                    </div>

                    <div className={"row mb-2"}>
                      <div className={"col-12 col-md-6 mb-2 mb-md-0"}>
                        <div className={"row"}>
                          <div className="col-6 col-md-6">
                            <b>Admin Coverage:</b>
                          </div>
                          <div className="col-6 col-md-6">
                          {kase.out_network_display ? kase.out_network_tab.admin_coverage : kase.in_network_tab.admin_coverage}
                        </div>
                        </div>
                      </div>
                      <div className={"col-12 col-md-6 mb-2 mb-md-0"}>
                        <div className={"row"}>
                          <div className="col-6 col-md-6">
                            <b>Admin copay:</b>
                          </div>
                          <div className="col-6 col-md-6">
                          {kase.out_network_display ? kase.out_network_tab.admin_copay : kase.in_network_tab.admin_copay}
                        </div>
                        </div>
                      </div>
                    </div>

                    <div className={"row mb-2"}>
                      <div className={"col-12 col-md-6 mb-2 mb-md-0"}>
                        <div className={"row"}>
                          <div className="col-6 col-md-6">
                            <b>Office Coverage:</b>
                          </div>
                          <div className="col-6 col-md-6">
                          {kase.out_network_display ? kase.out_network_tab.office_coverage : kase.in_network_tab.office_coverage}
                        </div>
                        </div>
                      </div>
                      <div className={"col-12 col-md-6 mb-2 mb-md-0"}>
                        <div className={"row"}>
                          <div className="col-6 col-md-6">
                            <b>Office Copay:</b>
                          </div>
                          <div className="col-6 col-md-6">
                          {kase.out_network_display ? kase.out_network_tab.office_copay : kase.in_network_tab.office_copay}
                        </div>
                        </div>
                      </div>
                    </div>

                    <div className={"row mb-2"}>
                      <div className={"col-12 col-md-6 mb-2 mb-md-0"}>
                        <div className={"row"}>
                          <div className="col-6 col-md-6">
                            <b>Deductible Met:</b>
                          </div>
                          <div className="col-6 col-md-6">
                          {kase.out_network_display ? kase.out_network_tab.deductible_met : kase.in_network_tab.deductible_met}
                        </div>
                        </div>
                      </div>
                      <div className={"col-12 col-md-6 mb-2 mb-md-0"}>
                        <div className={"row"}>
                          <div className="col-6 col-md-6">
                            <b>Deductible:</b>
                          </div>
                          <div className="col-6 col-md-6">
                          {kase.out_network_display ? kase.out_network_tab.deductible : kase.in_network_tab.deductible}
                        </div>
                        </div>
                      </div>
                    </div>

                    <div className={"row mb-2"}>
                      <div className={"col-12 col-md-6 mb-2 mb-md-0"}>
                        <div className={"row"}>
                          <div className="col-6 col-md-6">
                            <b>Out of Pocket Met:</b>
                          </div>
                          <div className="col-6 col-md-6">
                          {kase.out_network_display ? kase.out_network_tab.out_of_pocket_met : kase.in_network_tab.out_of_pocket_met}
                        </div>
                        </div>
                      </div>
                      <div className={"col-12 col-md-6 mb-2 mb-md-0"}>
                        <div className={"row"}>
                          <div className="col-6 col-md-6">
                            <b>Out of Packet Max:</b>
                          </div>
                          <div className="col-6 col-md-6">
                          {kase.out_network_display ? kase.out_network_tab.out_of_pocket_max : kase.in_network_tab.out_of_pocket_max}
                        </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-3">
                        <b>Med Ben Notes:</b>
                      </div>
                      <div className="col-md-9">
                        {kase.out_network_display ? kase.out_network_tab.med_ben_notes : kase.in_network_tab.med_ben_notes}
                      </div>
                      {(kase.category === 'medrx' || kase.category === 'rx') && (
                          <>
                            <div className="col-md-3">
                              <b>Rx Ben Notes:</b>
                            </div>
                            <div className="col-md-9">
                              {kase.rx_ben_notes ?? ''}
                            </div>
                          </>
                      )}
                    </div>
                  </div>
                </div>
              ))
              : <h4 className="text-center fw-bold">{(caseDetails.data as string)}</h4>)
              : null
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepperModal;

